import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-scroll',
  templateUrl: './scroll.component.html',
  styleUrls: ['./scroll.component.css']
})
export class ScrollComponent {

  @Input() scrollTarget: any;
  @Input() showSaveButton: boolean;
  @Output() onSaveEmitter = new EventEmitter();

  scrollTo(target) {
    target.scrollIntoView({behavior: 'smooth'});
  }

  onSave() {
    this.onSaveEmitter.emit();
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/scroll/scroll.component.ts